import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOracleComponent } from './simple-icons-oracle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOracleComponent ],
    exports:      [ SimpleIconsOracleComponent ],
    bootstrap:    []
})
export class SimpleIconsOracleModule {}
